$(() => {
    var Plaque = function () {
  		var id = "product-template-" + $('input[name*="product-template"]')[0].name.split('-')[2]
        this.radioName = id + "-1";
        this.materialName = id + "-2"; 
        this.depName = "properties[Département]";
        this.messageCheckboxName = "properties[_texte-plaque]";
        this.messageInputName = "texte-plaque-txt";
        this.plaqueInput = "properties[Votre plaque]";

        this.mode = "Auto";
        this.material = "Plexiglass";
        this.img = "";
        this.department = "00";
        this.hasMessageText = false;
        this.messageText = "";
        this.plaqueValue = "";

        this.currentImageObserver = () => {};
    };

    Plaque.prototype.setupForm = function () {
        $(window).resize(() => {
            this.renderSize();
        });

		this.mode = $("input[name='" + this.radioName + "']").val()
		this.material = $("input[name='" + this.materialName + "']").val()
        $("input[name='" + this.radioName + "']").change((event) => {
            this.mode = $(event.target).val();
            if (this.mode == "Moto") {
                $("input[name='" + this.materialName + "']").removeAttr("checked");
                $("input[name='" + this.materialName + "'][value='Plexiglass']").prop("checked", true);
                this.material = "Plexiglass";
            }
            this.render();
        });
  

		$("input[name='" + this.materialName + "']").change((event) => {
            this.material = $(event.target).val();
            this.render();
        });

        var checkPlaqueExist = setInterval(() => {
            if ($("input[name='" + this.plaqueInput + "']").length) {
                $("input[name='" + this.plaqueInput + "']").inputmask({ mask: "AA-999-AA", placeholder: "__-___-__" });
                $("input[name='" + this.plaqueInput + "']").keyup((event) => {
                    var value = $(event.target).val();
                    this.plaqueValue = value;
                    this.render();
                });
                clearInterval(checkPlaqueExist);
            }
        }, 100);

        var checkSelectExist = setInterval(() => {
            if ($('select[name="' + this.depName + '"]').length) {
                $("select[name='" + this.depName + "']").change((event) => {
                    $("input[name='properties[Logo " + this.department + "]']").unbind("change");
                    this.department = $(event.target).val();
                    this.render();

                    setTimeout(() => {
                        this.img = $("input[name='properties[Logo " + this.department + "]']:checked")
                            .parent()
                            .find(".spb-productoptionswatch")
                            .css("background-image")
                            .replace('url("', "")
                            .replace('")', "");
                        this.render();
                        $("input[name='properties[Logo " + this.department + "]']").change((event) => {
                            this.img = $(event.target)
                                .parent()
                                .find(".spb-productoptionswatch")
                                .css("background-image")
                                .replace('url("', "")
                                .replace('")', "");
                            this.render();
                        });
                    }, 300);
                });
                clearInterval(checkSelectExist);
            }
        }, 100);

        var checkMessageCheckExist = setInterval(() => {
            if ($("input[name='" + this.messageCheckboxName + "']").length) {
                $("input[name='" + this.messageCheckboxName + "']")
                    .parent()
                    .find("label input")
                    .change((event) => {
                        this.hasMessageText = $(event.target).is(":checked");
                        this.render();
                    });
                clearInterval(checkMessageCheckExist);
            }
        }, 100);

        var checkMessageInputExist = setInterval(() => {
            if ($("." + this.messageInputName).length) {
                $("." + this.messageInputName)
                    .find("input")
                    .keyup((event) => {
                        this.messageText = $(event.target).val();
                        this.render();
                    });
                clearInterval(checkMessageInputExist);
            }
        }, 100);

        this.render();
    };

    Plaque.prototype.render = function () {
        if (this.img) {
            $(".apv-img-placeholder").hide();
            $(".apv-autocollant-img").show();
            $(".apv-autocollant-img").attr("src", this.img);
        } else {
            $(".apv-img-placeholder").show();
            $(".apv-autocollant-img").hide();
        }

        if (this.plaqueValue.length <= 0) {
            this.plaqueValue = "__-___-__";
        }

        var finalMaterial = this.material;
        if (this.mode == "Auto") {
            $(".apv-auto").show();
            $(".apv-moto").hide();
        } else {
            $(".apv-moto").show();
            $(".apv-auto").hide();
            finalMaterial = "Plexiglass";
        }

        if (finalMaterial == "Plexiglass") {
            $(".apv-plaque").removeClass("apv-alumin");
        } else {
            $(".apv-plaque").addClass("apv-alumin");
        }

        var finalPlaqueHtml = "";
        this.plaqueValue.split("").forEach((a, i) => {
            var finalVal = a;
            if (a == "_") {
                if (i < 2) {
                    finalVal = "<span class='apv-p-muted'>A</span>";
                } else if (i < 6) {
                    finalVal = "<span class='apv-p-muted'>0</span>";
                } else {
                    finalVal = "<span class='apv-p-muted'>B</span>";
                }
            } else if (a == "-") {
                finalVal = "<span class='apv-p-separator'>-</span>";
            }
            if (this.mode == "Moto" && i == 2) {
                finalVal += "<br />";
            }
            finalPlaqueHtml += finalVal;
        });
        $(".apv-body-text").html(finalPlaqueHtml);

        if (this.hasMessageText) {
            $(".apv-custom-message").show();
            if (this.messageText.trim().length <= 0) {
                this.messageText = "<span class='apv-p-muted'>Votre message personnalis&eacute;</span>";
            }
        } else {
            $(".apv-custom-message").hide();
        }

        $(".apv-custom-message").html(this.messageText);

        if (this.department == "00") {
            $(".apv-autocollant-text").addClass("apv-muted");
        } else {
            $(".apv-autocollant-text").removeClass("apv-muted");
        }

        if (this.department.length < 3) {
            $(".apv-autocollant-text-tri").hide();
            $(".apv-autocollant-text").show();
            $(".apv-autocollant-text").html(this.department);
            var baseWidth = this.mode == "Auto" ? $($(".apv-autocollant")[0]).width() : $($(".apv-autocollant")[1]).width();
            var textWidth = this.mode == "Auto" ? $($(".apv-autocollant-text")[0]).width() : $($(".apv-autocollant-text")[1]).width();
            var ratio = this.mode == "Auto" ? 0.85 : 0.7;

            var textScale = (baseWidth / textWidth) * ratio;
            $(".apv-autocollant-text").css("transform", "scaleX(" + textScale + ")");
        } else {
            $(".apv-autocollant-text").hide();
            $(".apv-autocollant-text-tri").show();
            $(".aut-1").html(this.department[0]);
            $(".aut-2").html(this.department[1]);
            $(".aut-3").html(this.department[2]);
        }

        this.renderSize();
    };

    Plaque.prototype.renderSize = function () {
        var scale = $(".apv-preview-wrapper").parent().width() / $(".apv-preview-wrapper").width();
        $(".apv-preview-wrapper").css("transform", "scale(" + scale + ")");
        $(".apv-preview-wrapper")
            .parent()
            .css("height", $(".apv-preview-wrapper").height() * scale);
    };

    var instance = new Plaque();
    instance.setupForm();
});
